/**
 * AppVersionUpdateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * AppVersionUpdateReq
 */
export interface AppVersionUpdateReq {
  /** 版本ID */
  id: string
  /** 版本号 */
  version?: string
  /** 构建号 */
  build_number?: number
  /** 最低支持版本 */
  min_version?: string
  /** 更新策略 */
  update_strategy?: string
  /** 提醒间隔(秒) */
  remind_interval?: number
  /** 更新标题 */
  title?: string
  /** 更新日志 */
  release_notes?: any
  /** 下载链接 */
  download_url?: string
  /** 是否激活 */
  is_active?: boolean
}

/**
 * AppVersionUpdateReq Schema
 */
export const AppVersionUpdateReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '版本ID',
      format: 'string',
      type: 'string',
      label: '版本ID',
    },
    version: {
      description: '版本号',
      format: '*string',
      type: 'string',
      label: '版本号',
    },
    build_number: {
      description: '构建号',
      format: '*int',
      minimum: 1,
      type: 'integer',
      label: '构建号',
    },
    min_version: {
      description: '最低支持版本',
      format: '*string',
      type: 'string',
      label: '最低支持版本',
    },
    update_strategy: {
      description: '更新策略',
      enum: ['none', 'gentle', 'persistent', 'force'],
      format: '*string',
      type: 'string',
      label: '更新策略',
    },
    remind_interval: {
      description: '提醒间隔(秒)',
      format: '*int',
      minimum: 0,
      type: 'integer',
      label: '提醒间隔',
    },
    title: {
      description: '更新标题',
      format: '*string',
      maxLength: 100,
      type: 'string',
      label: '更新标题',
    },
    release_notes: {
      description: '更新日志',
      format: '*string',
      maxLength: 5000,
      type: 'text',
      label: '更新日志',
    },
    download_url: {
      description: '下载链接',
      format: '*string',
      maxLength: 500,
      type: 'string',
      label: '下载链接',
    },
    is_active: {
      description: '是否激活',
      format: '*bool',
      type: 'boolean',
      label: '是否激活',
    },
  },
  required: ['id'],
  type: 'object',
}
